import { useLocation } from "react-router"

import "./index.scss"
import { Title, Container, DurationInput, Select, Text } from "components/Form"
import { DateTime, Duration } from "luxon"
import useT from "utils/hooks/useT"

export default function PeopleSetup({
  setuptime,
  setSetuptime,
  isDraft,
  perSampleDuration,
  setPerSampleDuration,
  disabled,
  competenceGroups,
  allowedGroupIds,
  setAllowedGroupIds,
  startDate,
  setStartDate,
  startTime,
  setStartTime,
  teamTimeZone,
  task,
  // SPEC-047 (R17) / SPEC-068 (R21): the task being edited was due more than 3 days ago on an
  // executed analysis (DONE/FAILED samples), so its start is frozen (the backend refuses with a
  // 406) — ghost the start inputs below like in the parent. A newer or future task stays editable.
  startChangeBlocked = false,
}) {
  const location = useLocation()
  const { t } = useT("common")
  const isAssetView = location.pathname.includes("/asset-view")
  return (
    <div className="container-compartment">
      <p>{t("peopleSetup")}</p>
      {isAssetView && (
        <>
          <span
            className={startChangeBlocked ? "blocked-action-wrap" : undefined}
            style={startChangeBlocked ? { display: "block" } : undefined}
            title={startChangeBlocked ? t("blockedActionTaskBeyondMoveGrace") : undefined}
          >
            <Container>
              <Title>{t("fromDate")}</Title>
              <Text
                type="date"
                required
                disabled={disabled || startChangeBlocked}
                value={startDate ? startDate.toFormat("yyyy-MM-dd") : ""}
                onChange={(value) => {
                  if (!value) {
                    setStartDate(undefined)
                    return
                  }
                  try {
                    const newDate = DateTime.fromFormat(value, "yyyy-MM-dd").setZone(teamTimeZone, { keepLocalTime: true })
                    setStartDate(newDate)
                  } catch {
                    // Handle invalid date format
                  }
                }}
              />
              <Title>{t("fromTime")}</Title>
              <DurationInput
                disabled={disabled || startChangeBlocked}
                value={startTime}
                onChange={setStartTime}
                required
                isTime
              />
            </Container>
          </span>
          <Container>
            <Title>{t("toDate")}</Title>
            <Text
              type="date"
              required
              disabled
              value={DateTime.fromISO(task.end).setZone(teamTimeZone).toFormat("yyyy-MM-dd")}
            />
            <Title>{t("toTime")}</Title>
            <DurationInput
              disabled
              value={
                Duration.fromObject({
                  hours: DateTime.fromISO(task.end).setZone(teamTimeZone).hour,
                  minutes: DateTime.fromISO(task.end).setZone(teamTimeZone).minute,
                })
            }
            />
          </Container>
        </>
      )}
      <Container>
        <Title>
          {t("setuptime")}<div className="red-text">*</div>
        </Title>
        <DurationInput value={setuptime} onChange={setSetuptime} required={!isDraft} disabled={disabled} />
      </Container>
      <Container>
        <Title>{t("perSampleDuration")}</Title>
        <DurationInput required={!isDraft} withSeconds value={perSampleDuration} onChange={setPerSampleDuration} disabled={disabled} />
      </Container>
      <Container>
        <Title>
          {t("allowedCompetenceGroups")}<div className="red-text">*</div>
        </Title>
        <Select
          name={t("allowedCompetenceGroups")}
          disabled={disabled}
          required={!isDraft}
          collection={Object.values(competenceGroups).sort((a, b) => {
            if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
            if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
            return 0
          })}
          value={allowedGroupIds}
          onChange={setAllowedGroupIds}
          menuPosition="fixed"
        />
      </Container>
    </div>
  )
}
